import { render, staticRenderFns } from "./foodLaptopView.vue?vue&type=template&id=6bf07700&scoped=true&"
import script from "./foodLaptopView.vue?vue&type=script&lang=js&"
export * from "./foodLaptopView.vue?vue&type=script&lang=js&"
import style0 from "./foodLaptopView.vue?vue&type=style&index=0&id=6bf07700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf07700",
  null
  
)

export default component.exports